<template>
    <div>
      <h2>Invoices</h2>
      <ul>
        <li v-for="invoice in apartmentInvoices" :key="invoice.id">{{ invoice.amount }}</li>
      </ul>
    </div>
  </template>

  <script>
  import { mapState } from 'vuex';

  export default {
    name: 'Invoices',
    computed: {
      ...mapState(['apartmentInvoices']),
    },
  };
  </script>
